import {Container} from "@bryntum/schedulerpro";
import {getSavedBoardSelection} from "../../../react/hooks/useBoards.jsx";
import {getIsArchivedForBoard} from "../../../other/utils/otherUtils.jsx";
import SwivuEntityFinderPopup from "./SwivuEntityFinderPopup.jsx";
import { WIDGET_KEYS } from "../../../other/constants/WidgetKeys.jsx";

export default class EntityFinderTabBase extends Container {
  static get $name() {
    return "EntityFinderTabBase";
  }

   static getTabWidget(title, columnConfig) {
    return {
      title,
      items: [{
        type: WIDGET_KEYS.swivuPreferenceStyleGrid,
        ref: "entityGrid",
        readOnly: true,
        features: {
          cellEdit: false,
          cellMenu: false,
          stripe: { disabled: true },
        },
        selectionMode: { checkbox: true, checkboxOnly: true },
        height: "100%",
        hideHeaders: true,
        columns: [{ id: "entity-name", ...columnConfig, flex: 1}],
        listeners: {
          // Below function is defined in SwivuEntityFinderPopup class
          selectionChange: "up.onGridSelectionChange"
        }
      }]
    }
  }

  editRecord(record, context, otherParams) {
    this.loaded = false;
    this.record = record;
    Object.assign(this, context, otherParams);
    this.loadRecord(record, context, otherParams);

    // the entity finder editor opens from app header and contact linked to field
    // when opened from app header we don't want checkboxes to appear in the grid
    const { isOnlyFinder } = otherParams;
    if (isOnlyFinder) {
      // if the grid `hideHeader` property is set to false and then making the checkbox selection of grid to false then it breaks on console
      this.widgetMap.entityGrid.hideHeaders = false;
      this.widgetMap.entityGrid.selectionMode.checkbox = false;
      this.widgetMap.entityGrid.hideHeaders = true;

      this.widgetMap.entityGrid.onCellClick = (e) => {
        if (this.onOpenEntityEditor) {
          this.onOpenEntityEditor(e);

          // close entity finder after the editor is opened
          setTimeout(() => {
            const entityFinder = this.up(SwivuEntityFinderPopup.type);
            if (entityFinder) {
              entityFinder.close();
            }
          }, 100); // let the entity to open first before closing the entity finder otherwise the finder will never close
        }
      };
    }
    this.loaded = true;
  }

  loadRecord(record, context, _otherParams) {
    const { entityGrid } = this.widgetMap;
    const selectedBoard = getSavedBoardSelection();
    // Todo: Remove !entityRecord.isLinked, once fix bryntum issue
    // issue link: https://github.com/bryntum/support/issues/9840
    entityGrid.store.data = context.project.getCrudStore(this.storeKey).query(
      (entityRecord) => (getIsArchivedForBoard(selectedBoard.slug) || !entityRecord.archived) && !entityRecord.isLinked,
      true
    );
  }
}
